import { useSiteSettings } from "../contexts/SiteSettingsContext";

export const Logo = ({ className = "" }) => {
  const { settings } = useSiteSettings();
  const logoUrl = settings?.logo_url;
  const siteName = settings?.site_name || "Maxlive88";

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={siteName}
        data-testid="brand-logo"
        className={`h-10 sm:h-12 w-auto object-contain select-none ${className}`}
      />
    );
  }

  return (
    <div
      data-testid="brand-logo"
      className={`font-display select-none leading-none ${className}`}
      aria-label={siteName}
    >
      <span className="text-white">Maxlive</span>
      <span className="text-[#ff2740]">88</span>
    </div>
  );
};
